import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, TreeSelect } from "antd";
import axiosInstance from "@/axios/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import UploadAgreement from "@/components/UploadAgreement";
import { tutorial_tag } from "@/assets/jfData";

import MyCustomUploadAdapterPlugin from "@/assets/MyEditorComponent";
import "./index.scss";
const { TextArea } = Input;
const findMatchedItems = (label) => {
  if (!label) return null;
  const matchedChild = tutorial_tag.find((child) => child.key === label);
  if (matchedChild) {
    return matchedChild.key;
  }
  return null;
};

const PublishTutorial = () => {
  const navigate = useNavigate(); // 获取 navigate 函数
  const [form] = Form.useForm();
  const [agreeToUpload, setAgreeToUpload] = useState(true); // 默认勾选
  const [editorData, setEditorData] = useState("");
  const [cover, setCover] = useState("");
  const [dataDetail, setDatali] = useState({});
  const [content, setContent] = useState("");

  let location = useLocation();
  let { state } = location;
  let itemId = state?.id;
  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `tutorial/account/detail?tutorialId=${id}`
      );
      setDatali(response.data.data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    if (itemId) {
      fetchDetails(itemId); // 如果itemId存在，
    }
  }, [itemId]);
  useEffect(() => {
    // 当dataDetail更新时，更新表单的值
    if (Object.keys(dataDetail).length > 0) {
      const matchedTag = findMatchedItems(dataDetail.label + "");

      // 先设置其他字段
      form.setFieldsValue({
        title: dataDetail.title,
        digest: dataDetail.digest,
        content: dataDetail.content,
      });

      // 单独设置标签值
      form.setFieldValue("tags", matchedTag);

      setCover(dataDetail.cover + "");
      setEditorData(dataDetail.content);
    }
  }, [dataDetail, form]);
  const onFinish = (values) => {
    // 邮箱格式正确，执行提交操作
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("digest", values.digest);
    formData.append("content", content);
    formData.append("label", values.tags);
    formData.append("cover", cover);
    let url = "/tutorial/account/save";

    if (itemId) {
      formData.append("tutorialIdArray", itemId);
      url = "/tutorial/account/update";
    }
    try {
      axiosInstance
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "10000") {
            message.success("保存成功");
            navigate("/personal?selectedKey=2&openKeys=sub2&openKeys=sub1");
          } else {
            message.error("保存失败");
          }
        })
        .catch((error) => {
          // 处理错误情况
          console.error("Error fetching user info:", error);
        });
    } catch (error) {
      // 处理错误情况
      console.error("Error fetching user info:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const handleChanges = async (value, label, extra) => {
    if (value) {
      try {
        // 调用图片接口获取对应标签的封面图
        const response = await axiosInstance.get(`/sys/image/labelImageUrl`, {
          params: {
            type: 8,
            labelType: value,
          },
        });
        if (response.data.code === 10000 && response.data.data.imageUrl) {
          // 获取第一张图片的URL作为教程封面
          const coverUrl = response.data.data.imageUrl;
          setCover(coverUrl);
        }
      } catch (error) {
        console.error("Error fetching cover image:", error);
        message.error("获取封面图片失败");
      }
    }
  };
  const onReset = () => {
    form.resetFields();
    navigate("/personal?selectedKey=2&openKeys=sub2&openKeys=sub1");
  };
  return (
    <Form
      form={form}
      {...formItemLayout}
      name="tutorial_form"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="标题"
        name="title"
        rules={[{ required: true, message: "请输入标题!" }]}
      >
        <Input showCount maxLength={60} />
      </Form.Item>

      <Form.Item
        label="摘要"
        name="digest"
        rules={[{ required: true, message: "请输入摘要!" }]}
      >
        <TextArea
          showCount
          style={{
            height: 200,
            resize: "none",
          }}
          maxLength={200}
        />
      </Form.Item>
      <Form.Item
        name="content"
        label="内容"
        rules={[{ required: true, message: "请输入内容!" }]}
      >
        <MyCustomUploadAdapterPlugin value={content} onChange={setContent} />
      </Form.Item>
      <Form.Item
        name="tags"
        label="教程标签"
        rules={[
          {
            required: true,
            message: "请选择一个标签",
          },
        ]}
      >
        <TreeSelect
          style={{ width: "300px" }}
          placeholder="请选择"
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          treeData={tutorial_tag}
          treeDefaultExpandAll
          onChange={handleChanges}
          allowClear
          showSearch
        />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
        <UploadAgreement checked={agreeToUpload} onChange={setAgreeToUpload} />
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "40px", marginBottom: "30px" }}
        >
          提交
        </Button>
        <Button htmlType="button" onClick={onReset}>
          取消
        </Button>
      </Form.Item>
    </Form>
  );
};
export default PublishTutorial;
